<template>
  <div class="menu">
    <loadingSpinner mode="inline" v-if="!modulesLoaded || !platformPermissionsLoaded || !platformRolesLoaded" :content="$t('menu.Loading_menu')"/>
    <div v-else-if="modulesLoaded && platformPermissionsLoaded && platformRolesLoaded && showMenu">
      <!-- SatisQuestions -->
      <CDropdown v-if="modules.satisquestions === 1 && checkProductPermissions('measure')" color="primary" toggler-text="" :caret="false" class="ml-0 mr-3">
        <div slot="toggler-content">
          <span class="d-flex align-items-center">
            SatisQuestions<i class="fas fa-caret-down ml-1"></i>
          </span>
        </div>
        
        <CDropdownItem v-if="checkPermission('measure.sq.overview')" @click="navigateToPath('/measure/satisquestions')">
          <i class="fas fa-clipboard-question"></i>Survey
        </CDropdownItem>
        <CDropdownItem  v-if="checkPermission('measure.bm.overview') && modules.burning_matters === 1" @click="navigateToPath('/measure/burning-matters')">
          <i class="fa-solid fa-fire"></i>Burning Matters
        </CDropdownItem>
        <CDropdownItem v-if="checkPermission('measure.configure')" @click="navigateToPath('/measure/configure')">
          <i class="fas fa-cog"></i>Configure
        </CDropdownItem>
      </CDropdown>

      <!-- Spark Moments -->
      <CDropdown v-if="modules.employee_loyalty_programme === 1 && checkProductPermissions('loyalty')" color="primary" toggler-text="" :caret="false" class="ml-0 mr-3">
        <div slot="toggler-content">
          <span class="d-flex align-items-center">
            Spark Moments<i class="fas fa-caret-down ml-1"></i>
          </span>
        </div>
        
        <CDropdownItem v-if="modules.loyalty_moments === 1 && checkPermission('loyalty.moments.overview')" @click="navigateToPath('/loyalty/moments')">
          <i class="fa-solid fa-envelope-open-text"></i>Sparks
        </CDropdownItem>
        <CDropdownItem v-if="checkPermission('loyalty.smartmoments.overview') && ['business', 'enterprise'].includes(productLicenses.loyalty_license_tag) && modules.loyalty_smart_moments === 1" @click="navigateToPath('/loyalty/smart-moments')">
          <i class="fa-solid fa-calendar-day"></i>Smart Sparks
        </CDropdownItem>
        <CDropdownItem v-if="modules.loyalty_benefits_moments === 1 && checkPermission('loyalty.benefits.moments.overview')" @click="navigateToPath('/loyalty/benefits/moments')">
          <i class="fa-solid fa-calendar-day"></i>Benefits Moments
        </CDropdownItem>
        <CDropdownItem v-if="checkPermission('loyalty.store.overview')" @click="navigateToPath('/loyalty/store')">
          <i class="fas fa-store"></i>Spark Shop
        </CDropdownItem>
        <CDropdownItem v-if="checkPermission('loyalty.orders.overview')" @click="navigateToPath('/loyalty/orders')">
          <i class="fas fa-receipt"></i>Orders
        </CDropdownItem>
        <CDropdownItem v-if="checkPermission('loyalty.momentsenders.overview') || (checkPermission('loyalty.budgetcaps') && ['business', 'enterprise'].includes(productLicenses.loyalty_license_tag))" @click="navigateToPath('/loyalty/configure')">
          <i class="fas fa-cog"></i>Configure
        </CDropdownItem>
        <CDropdownItem v-if="company.payment_setup_completed === true && company.payment_type_tag === 'prepaid' && checkPermission('core.payments.prepaid.topup')" @click="navigateToPath('/core/payments/prepaid/topup')">
          <i class="fas fa-square-up-right"></i>Top Up Wallet Balance
        </CDropdownItem>
      </CDropdown>
      
      <!-- Company Topics -->
      <CDropdown v-if="modules.social_wall === 1 && checkProductPermissions('connect')" color="primary" toggler-text="" :caret="false" class="ml-0 mr-3">
        <div slot="toggler-content">
          <span class="d-flex align-items-center">
            Company Topics<i class="fas fa-caret-down ml-1"></i>
          </span>
        </div>
        <CDropdownItem v-if="checkPermission('connect.sw.overview')" @click="navigateToPath('/connect/schedule')">
          <i class="fas fa-comments"></i>Connect
        </CDropdownItem>
        <CDropdownItem v-if="checkPermission('connect.flows.overview')" @click="navigateToPath('/connect/flows')">
          <i class="fas fa-stream"></i>Feeds
        </CDropdownItem>
        <CDropdownItem v-if="checkPermission('connect.deliver.overviewcampaigns') || checkPermission('connect.deliver.overviewtemplates') || modules.push_notifications === 1" @click="navigateToPath('/connect/deliver')">
          <i class="fas fa-envelope"></i>Deliver
        </CDropdownItem>
        <CDropdownItem v-if="checkPermission('connect.senders.overview')" @click="navigateToPath('/connect/senders')">
          <i class="fas fa-users"></i>Senders
        </CDropdownItem>
        <CDropdownItem v-if="checkPermission('connect.topics.overview')" @click="navigateToPath('/connect/topics')">
          <i class="fas fa-list-ul"></i>Topics
        </CDropdownItem>
        <CDropdownItem v-if="(checkPermission('connect.signage.overview') || checkPermission('connect.signage.tickeroverview')) && modules.signage === 1" @click="navigateToPath('/connect/signage')">
          <i class="fab fa-chromecast"></i>Signage
        </CDropdownItem>
        <CDropdownItem v-if="modules.connect_chats === 1 && checkPermission('connect.chats')" @click="navigateToPath('/connect/chats')">
          <i class="fas fa-comments"></i>Chats
        </CDropdownItem>
      </CDropdown>
      
      <!-- Brain Base -->
      <CDropdown v-if="modules.social_kb === 1 && checkProductPermissions('knowledge')" color="primary" toggler-text="" :caret="false" class="ml-0 mr-3">
        <div slot="toggler-content">
          <span class="d-flex align-items-center">
            Brain Base<i class="fas fa-caret-down ml-1"></i>
          </span>
        </div>
        <CDropdownItem v-if="checkPermission('knowledge.library.overview')" @click="navigateToPath('/knowledge/library')">
          <i class="fas fa-book"></i>Library
        </CDropdownItem>
        <CDropdownItem v-if="checkPermission('knowledge.submissions.overview')" @click="navigateToPath('/knowledge/submissions')">
          <i class="fas fa-inbox"></i>Submissions
        </CDropdownItem>
        <CDropdownItem v-if="checkPermission('knowledge.feedback')" @click="navigateToPath('/knowledge/feedback')">
          <i class="fas fa-headset"></i>Feedback
        </CDropdownItem>
      </CDropdown>
      
      <!-- Grow Station -->
      <CDropdown v-if="modules.academy === 1 && checkProductPermissions('learn')" color="primary" toggler-text="" :caret="false" class="ml-0 mr-3">
        <div slot="toggler-content">
          <span class="d-flex align-items-center">
            Grow Station<i class="fas fa-caret-down ml-1"></i>
          </span>
        </div>
        <CDropdownItem v-if="checkPermission('learn.catalog.overview')" @click="navigateToPath('/learn/catalog')">
          <i class="fas fa-graduation-cap"></i>Catalog
        </CDropdownItem>
        <CDropdownItem v-if="checkPermission('learn.onboarding.overview')" @click="navigateToPath('/learn/onboarding')">
          <i class="fas fa-hands-helping"></i>Onboarding
        </CDropdownItem>
      </CDropdown>
      
      <!-- Service Spot -->
      <CDropdown v-if="modules.service === 1 && checkProductPermissions('service')" color="primary" toggler-text="" :caret="false" class="ml-0 mr-3">
        <div slot="toggler-content">
          <span class="d-flex align-items-center">
            Service Spot<i class="fas fa-caret-down ml-1"></i>
          </span>
        </div>
        <CDropdownItem v-if="checkPermission('service.center')" @click="navigateToPath('/service/questions')">
          <i class="fas fa-question-circle"></i>Questions
        </CDropdownItem>
        <CDropdownItem v-if="checkPermission('service.folders.overview')" @click="navigateToPath('/service/questions/folders')">
          <i class="fa-solid fa-folder"></i>Folders
        </CDropdownItem>
        <CDropdownItem v-if="modules.service_forms === 1 && checkPermission('service.forms.overview')" @click="navigateToPath('/service/forms')">
          <i class="fa-solid fa-file-lines"></i>Forms
        </CDropdownItem>
        <CDropdownItem v-if="modules.service_forms === 1 && checkPermission('service.forms.submissions')" @click="navigateToPath('/service/forms/submissions')">
          <i class="fa-solid fa-inbox"></i>Submissions
        </CDropdownItem>
      </CDropdown>
      
      <!-- Hub -->
      <CDropdown v-if="modules.resources_in_app === 1 && checkProductPermissions('hub')" color="primary" toggler-text="" :caret="false" class="ml-0 mr-3">
        <div slot="toggler-content">
          <span class="d-flex align-items-center">
            Hub<i class="fas fa-caret-down ml-1"></i>
          </span>
        </div>
        <CDropdownItem v-if="checkPermission('hub.resources.overview')" @click="navigateToPath('/hub/resources')">
          <i class="fas fa-user-gear"></i>Resources
        </CDropdownItem>
      </CDropdown>

      <!-- Insights -->
      <div v-if="company.payment_status === true && checkProductPermissions('insights')" class="single_item mr-3">
        <CButton color="primary" @click="navigateToPath('/insights')">
          <span class="d-flex align-items-center">Insights</span>          
        </CButton>
      </div>      
      
      <!-- Core -->
      <CDropdown v-if="checkProductPermissions('core')" color="primary" toggler-text="" :caret="false" class="ml-0 mr-3">
        <div slot="toggler-content">
          <span class="d-flex align-items-center">
            Core<i class="fas fa-caret-down ml-1"></i>
          </span>
        </div>
        <CDropdownItem v-if="checkPermission('core.organization.overview')" @click="navigateToPath('/core/organization')">
          <i class="fas fa-user-friends"></i>Organization
        </CDropdownItem>
        <CDropdownItem v-if="checkPermission('core.targetgroups.overview')" @click="navigateToPath('/core/target-groups')">
          <i class="fas fa-users-cog"></i>Target groups
        </CDropdownItem>
        <CDropdownItem v-if="checkPermission('core.lookandfeel')" @click="navigateToPath('/core/look-and-feel')">
          <i class="fas fa-palette"></i>Look and Feel
        </CDropdownItem>
        <CDropdownItem v-if="checkPermission('core.emailtemplates')" @click="navigateToPath('/core/email/templates')">
          <i class="fas fa-clipboard"></i>Email Templates
        </CDropdownItem>
      </CDropdown>

      <!-- Super Admin -->
      <div v-if="checkRole('super_admin')" class="single_item mr-3">
        <CButton color="primary" @click="navigateToPath('/admin')">
          <span class="d-flex align-items-center">Admin</span>          
        </CButton>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import loadingSpinner from '@/components/common/loadingSpinner.vue';

export default {
  name: 'TheHeaderMenu',
  components: {
    loadingSpinner
  },  
  data() {
    return {
      modules: {},
      modulesLoaded: false,
      platformPermissions: [],
      platformPermissionsLoaded: false,
      platformRoles: [],
      platformRolesLoaded: false,
      productLicenses: {
        loyalty_licence_tag: null
      },
      company: {
        details: {},
        get_started_completed: false,
        look_and_feel: {},
        payment_status: false,
        payment_setup_completed: false,
        payment_type_tag: null
      },      
      showMenu: false
    }
  },
  methods: {
    navigateToPath(newPath) {
      if(this.$router.currentRoute.path !== newPath) this.$router.push({path: newPath});
    },
    getCompanyDetails() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/company')
      .then(res => {      
        this.company = res.data.data;
      })
      .catch(err => {
        console.error(err); 
      });
    },    
    getPlatformRoles() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/platform/roles')
      .then(res => {      
        this.platformRoles = res.data.data;
        // Set the showMenu value
        this.showMenu = (this.platformRoles.length === 1 && this.platformRoles.includes('loyalty')) ? false : true;
        // Update the platformRolesLoaded value        
        this.platformRolesLoaded = true;
      })
      .catch(err => {
        console.error(err); 
      });
    },       
    getPlatformPermissions() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/platform/permissions')
      .then(res => {      
        this.platformPermissions = res.data.data;
        // Check if the user has permissions for company details
        if(this.platformPermissions.includes('core.company.details')) this.getCompanyDetails();
        // Update the platformPermissionsLoaded value        
        this.platformPermissionsLoaded = true;        
      })
      .catch(err => {
        console.error(err); 
      });
    },
    checkPermission(permissionTag) {    
      if(this.platformPermissions.includes(permissionTag)) {
        return true;
      } else{
        return false;
      }
    },
    checkProductPermissions(productTag) {
      let hasProductPermission = false;      

      this.platformPermissions.find(permission => { 
        if(permission.includes(productTag)) {
          hasProductPermission = true;
        }

        if(productTag === 'core' && ['core.company.details'].includes(permission)) {
          hasProductPermission = false;
        }

        for(var r = 0; r < this.platformRoles.length; r++) {
          if(['core', 'insights'].includes(productTag) && ['loyalty', 'loyalty_benefits_moment_editor'].includes(this.platformRoles[r])) {
            hasProductPermission = false;  
          }
        }
      });

      return hasProductPermission;
    },
    checkRole(roleTag) {
      if(this.platformRoles.includes(roleTag)) {
        return true;
      } else{
        return false;
      }
    },
    checkModules() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/platform/modules')
      .then(res => {
        this.modules = res.data.data;
        // Update the modulesLoaded value
        this.modulesLoaded = true;
      })
      .catch(err => {
        console.error(err); 
      });
    },  
  },
  created: function() {
    // Get the platform modules
    this.checkModules();
    // Wait 500ms and get the platform permissions and roles
    setTimeout(function() {      
      this.getPlatformPermissions();
      this.getPlatformRoles();
    }.bind(this), 500);
  },   
  async mounted() {
    this.productLicenses = await this.fetchProduuctLicenseData();
  }
}
</script>